'use client'

import { useQuery } from '@tanstack/react-query'
import { dataClient } from '@/lib/amplify'
import { getOperationsReport } from '@/lib/api/operations'
import { useSession } from './useSession'

export const OPERATIONS_QUERY_KEY = ['operations'] as const

/**
 * The Operations report, re-read every minute while the page is open: it is a page someone leaves
 * up during an incident, and an alarm that cleared five minutes ago should not still be red.
 */
export function useOperations() {
    const { isAdmin } = useSession()
    return useQuery({
        queryKey: OPERATIONS_QUERY_KEY,
        queryFn: async () => getOperationsReport(await dataClient()),
        enabled: isAdmin,
        staleTime: 30_000,
        refetchInterval: 60_000,
    })
}
